export const useMediaQuery = (query) => {
  const matches = ref(true)

  onMounted(() => {
    const media = window.matchMedia(query)
    matches.value = media.matches

    const updateMatches = (e) => {
      matches.value = e.matches
    }

    media.addEventListener('change', updateMatches)

    onUnmounted(() => {
      media.removeEventListener('change', updateMatches)
    })
  })

  return matches
}
